import { Outbox } from "@mui/icons-material";
import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

export enum DisabledRecipientReportActionEnum {
    NotifyMe = 'notifyme'
}

const actionEnums = [
    BaseActionEnum.Export,
    BaseActionEnum.Refresh,
];

export const disabledRecipientsReportActionItems = [...getActionMenuItems(actionEnums), {

    id: 'notify',
    label: i18n.t("actions.notifyMe"),
    icon: () => < Outbox />,
    action: DisabledRecipientReportActionEnum.NotifyMe,
    order: 5,
 }].map(o => {

    if (o.action === BaseActionEnum.Export) {
        if (o.subActions) {
            o.subActions = o.subActions.filter(o => o.action !== BaseActionEnum.PDF )
        }
    }
    return o;
});   